<template>
  <div class="crpg-a-private-cruising">
    <h2>{{ title01 }}</h2>
    <h2>
      <span class="l">{{ title02 }}</span
      ><span class="m">{{ title03 }}</span>
    </h2>
    <h2 class="content newline">{{ title04 }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    title01: String,
    title02: String,
    title03: String,
    title04: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/atoms/common/freeTopTitle.scss";
</style>
